import { createContext, useContext, ReactNode } from "react";
import {
  useUnifiedWebSocket,
  type UnifiedWebSocketAPI,
} from "@/hooks/use-unified-websocket";

const WebSocketContext = createContext<UnifiedWebSocketAPI | null>(null);

interface WebSocketProviderProps {
  children: ReactNode;
  userId?: string;
  userRole?: string;
}

export function WebSocketProvider({
  children,
  userId,
  userRole,
}: WebSocketProviderProps) {
  const ws = useUnifiedWebSocket({ userId, userRole });

  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket(): UnifiedWebSocketAPI {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }
  return context;
}
